import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import JobMatchForm from './JobMatchForm'
import JobProfileSummary from "./JobProfileSummary";
import Component from "../../../components/Component";
import LoadingSpinner from "../../../components/LoadingSpinner";
import JobDetails from "../JobDetails";
import {AuthContext} from "../../../providers/AuthProvider";
import {Divider} from "antd";

class JobMatchScoreModal extends Component {
    //contextType of the component is AuthContext. i.e this.context.auth = TB auth user
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            showJobMatchScores: !props.skipMatch
        }
    }

    async componentDidMount() {
        super.componentDidMount();


        await TB.wait(350);
        if (this.props.job.matching) {
            return this.promisedState({job: this.props.job, isLoading:false})
        }

        let job = await this.context?.auth?.updateForProjectPositionMatching(this.props.job, {})

        if (!job) {
            await this.promisedState({isLoading:false})

            await TB.showServerErrorToast();
            return this.props.onRequestClose();
        }

        return this.promisedState({job, isLoading:false})
    }

    render() {

        let {
            isLoading,
            showJobMatchScores,
            job
        } = this.state;

        return (
            <div className="job-match-score-panel">

            <div className="job-match-header">
                {this.props.title || (
                    <h5>My Match Score for this Job: <b>{this.props.job.title}</b></h5>
                )}
            </div>

                {isLoading && (
                    <div className="job-match-loading">
                        <LoadingSpinner size={'lg'}/>
                    </div>
                )}

                {!isLoading && job.matching && (
                    <>
                        {showJobMatchScores ? (
                            <div className="py-4 flex flex-col items-stretch gap-1">
                                <p className="font-semibold px-3 text-lg">
                                    Please review the client’s requirements compared to what’s in your profile. If
                                    you have experience in missing areas (in gray), you can add them to your profile here.</p>
                                <Divider/>
                                <JobMatchForm {...this.props} job={job}/>
                            </div>
                        ) : (
                            <JobProfileSummary {...this.props} />
                        )}
                        <div className="job-match-footer flex flex-row m-0 flex-nowrap lg:justify-end gap-3 md:justify-between">

                            {!this.props.skipMatch && !showJobMatchScores && (
                                <button className="btn btn-outline-dark" onClick={() => {
                                    this.setState({showJobMatchScores: true})
                                }}>
                                    Back
                                </button>
                            )}
                            {showJobMatchScores ? (
                                <Link
                                    to={{
                                        pathname: JobDetails.pathForJob(job)
                                    }}
                                    onClick={() => {
                                        this.props.onRequestClose()
                                    }}
                                    disabled={this.props.disabled}
                                    className="btn btn-primary"
                                >

                                    View Job Details
                                </Link>
                            ) : (
                                <Link to="/talent/application"
                                      onClick={() => {
                                          this.props.onRequestClose()
                                      }}
                                      className="btn btn-primary">
                                    Edit Profile
                                </Link>
                            )}
                            {showJobMatchScores ? (
                                <button disabled={this.props.disabled} className="btn btn-outline-dark" onClick={async() => {
                                    await this.promisedState({showJobMatchScores: false});
                                    if (this.props.onScrollTop) {
                                        return this.props.onScrollTop()
                                    }
                                }}>
                                    Next
                                </button>
                            ) : (
                                <button disabled={this.props.disabled} className="btn btn-outline-dark" onClick={this.props.onRequestClose}>
                                    Close
                                </button>
                            )}
                        </div>
                    </>
                )}
        </div>

        )
    }
}

JobMatchScoreModal.propsTypes = {
    onUpdateJob: PropTypes.func,
    onRequestClose: PropTypes.func,
    job: PropTypes.object
}

export default JobMatchScoreModal;